module.exports = __webpack_public_path__ + "img/logo-data-studio.292bc176.jpg";